import React, { useEffect, useState } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import {
  fetchAssignments,
  fetchAssignmentsByPath,
} from 'actions/assignmentActivity/assignments';
import { createStore } from 'stores/assignmentsActivity';
import { Spinner } from 'ui';
import ReminderModal from 'components/ReminderModal';
import Pagination from 'components/shared/pagination';
import AssignmentTable from './AssignmentTable';
import IncompleteAssingmentModal from './IncompleteAssignmentModal';

const store = createStore();

const AssignmentIncomplete = () => {
  const dispatch = useDispatch();
  const [reminder, setReminder] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [remindAllUsers, setRemindAllUsers] = useState(null);
  const [incompleteActionModal, setIncompleteActionModal] = useState(false);

  const directAssignmentUrl = window.location.pathname;
  const path = directAssignmentUrl.split('/');
  const assignmentId = path[2];
  const assignByPathUrl = `${directAssignmentUrl}/assigned_via_path`;
  const { loading, assignDirectly, assignViaPath, meta, pagination } =
    useSelector(state => state);

  useEffect(() => {
    dispatch(fetchAssignments(directAssignmentUrl));
    if (path[1] === 'lessons') {
      dispatch(fetchAssignmentsByPath(assignByPathUrl));
    }
    //eslint-disable-next-line
  }, [directAssignmentUrl, assignByPathUrl]);

  const pageChange = page => {
    if (page === 1) {
      dispatch(fetchAssignments(directAssignmentUrl));
      if (path[1] === 'lessons') {
        dispatch(fetchAssignmentsByPath(assignByPathUrl));
      }
    } else {
      dispatch(fetchAssignments(`${directAssignmentUrl}?page=${page}`));
      if (path[1] === 'lessons') {
        dispatch(fetchAssignmentsByPath(`${assignByPathUrl}?page=${page}`));
      }
    }
  };

  const getTitle = title => {
    if (title === 'learning_paths/path') {
      return 'path';
    }
    if (title.includes('group')) {
      return 'group';
    }
    return title;
  };

  if (loading) {
    return (
      <div className="mt-16 ta-c">
        <Spinner size="larger" />
      </div>
    );
  }

  return (
    <>
      <div className="panel assignments lesson" data-testid="panel-header">
        <header>
          <h4>
            {t('assignments.header.for_the', {
              type: getTitle(meta.metadata.title),
            })}
            <a className="decorated" href={meta.metadata.titleUrl}>
              {meta.metadata.titleName}
            </a>
          </h4>
          <h1>{t(`assignments.${meta.metadata.status}.title`)} </h1>
        </header>
        {assignDirectly.assignDirectly && (
          <div className="panel_body Module">
            <header>
              <h3 className="Module-heading">
                {t('assignments.assigned.directly')}
              </h3>
            </header>
            <AssignmentTable
              assignment={assignDirectly.assignDirectly}
              metadata={meta.metadata}
              hideSelect={false}
              hideAction={false}
              setReminder={setReminder}
              isManuallyTextAssignmentReminders={
                meta.isManuallyTextAssignmentReminders
              }
              assignmentId={assignmentId}
              setSelectedId={setSelectedId}
              setRemindAllUsers={setRemindAllUsers}
              setIncompleteActionModal={setIncompleteActionModal}
            />
          </div>
        )}
        {pagination.pages > 1 && (
          <Pagination
            className="mb-32"
            pages={pagination.pages}
            pageSelectCallback={pageChange}
            selected={pagination.selected}
          />
        )}
        {assignViaPath &&
          assignViaPath.map(assignmentData => {
            return (
              <div key={assignmentData.pathTitle} className="panel_body Module">
                <header>
                  <h3 className="Module-heading">
                    {t('assignments.assigned.through_path')}{' '}
                    <a className="decorated" href={assignmentData.pathUrl}>
                      {`“${assignmentData.pathTitle}”`}
                    </a>
                  </h3>
                </header>
                <AssignmentTable
                  assignment={assignmentData.assignments}
                  metadata={meta.metadata}
                  hideSelect
                  hideAction
                  setReminder={setReminder}
                  isManuallyTextAssignmentReminders={false}
                  assignmentId={assignmentId}
                  setSelectedId={setSelectedId}
                  setRemindAllUsers={setRemindAllUsers}
                  setIncompleteActionModal={setIncompleteActionModal}
                />
                {assignmentData.pagination.pages > 1 && (
                  <Pagination
                    className="mt-32"
                    pages={assignmentData.pagination.pages}
                    pageSelectCallback={pageChange}
                    selected={assignmentData.pagination.selected}
                  />
                )}
              </div>
            );
          })}
      </div>
      {reminder && remindAllUsers && (
        <ReminderModal
          assignmentIds={remindAllUsers.assignment_ids}
          cannotReceiveSmsCount={remindAllUsers.cannot_receive_sms_count}
          assigneeCount={remindAllUsers.assignee_count}
          isVisible={reminder}
          setReminder={setReminder}
          setSelectedId={setSelectedId}
          companyName={meta.companyName}
          remindAllUsers={remindAllUsers.remind_all_users}
        />
      )}
      {incompleteActionModal && (
        <IncompleteAssingmentModal
          selectedIds={selectedId || assignDirectly.selectedIds}
          singleId={selectedId}
          isVisible={incompleteActionModal}
          setShowModal={setIncompleteActionModal}
          setSelectedId={setSelectedId}
        />
      )}
    </>
  );
};

export default props => (
  <Provider store={store}>
    <AssignmentIncomplete {...props} />
  </Provider>
);
